import * as React from 'react';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import NotificationModel from '../../application/core/Notification';
import State from '../../application/core/State';
import { connect } from 'react-redux';
import EstimationsPlaceSucceed from '../../application/estimations/events/EstimationsPlaceSucceed';
import Event from '../../application/core/Event';
import './Popup.css';
import NotificationConsumed from '../../application/core/events/NotificationConsumed';
import TermsRequested from 'src/application/estimations/events/TermsRequested';
import OrderTerms from '../OrderTerms';
import OrderPlaceSucceed from '../../application/order/events/OrderPlaceSucceed';
import PopupEstimationsPlaced from './PopupEstimationsPlaced';
import PopupOrdersPlaced from './PopupOrdersPlaced';
import close from './close.svg';
import { fromEvent } from 'rxjs/index';
import { debounceTime, filter } from 'rxjs/internal/operators';
import OrderImportSucceed from '../../application/order/events/OrderImportSucceed';
import PopupOrdersImported from './PopupOrdersImported';
import RemoveCustomerRequested from '../../application/estimations/events/RemoveCustomerRequested';
import RemoveCustomer from '../RemoveCustomer';
import ResetPasswordRequested from '../../application/estimations/events/ResetPasswordRequested';
import ResetPassword from '../ResetPassword';

interface StateProps {
    notifications: NotificationModel[];
}

class Popup extends React.PureComponent<StateProps & DispatchProps> {
    public componentDidMount(): void {
        fromEvent(document, 'mouseup')
            .pipe(
                debounceTime(1),
                filter(() => this.getNotifications().length > 0)
            )
            .subscribe(this.closePopup);
    }

    public render(): JSX.Element | null {
        return this.getNotifications().length > 0 ? (
            <div className="popup">
                <div className="content">
                    <div className="popup-close" onClick={this.closePopup}>
                        <img src={close} />
                    </div>
                    {this.renderSpecificPopup()}
                </div>
            </div>
        ) : null;
    }

    private getNotifications = (): NotificationModel[] =>
        this.props.notifications.filter((notification: NotificationModel) => notification.data.event !== undefined);

    private renderSpecificPopup = (): JSX.Element | null => {
        const event: Event = this.getNotifications()[0].data.event!;
        document.body.classList.add('no-scroll');
        switch (event.type) {
            case EstimationsPlaceSucceed.type:
                return <PopupEstimationsPlaced placedEstimations={(event as EstimationsPlaceSucceed).estimations} />;
            case TermsRequested.type:
                return <OrderTerms />;
            case RemoveCustomerRequested.type:
                return <RemoveCustomer customerId={(event as RemoveCustomerRequested).customerId} />;
            case ResetPasswordRequested.type:
                return <ResetPassword customerId={(event as ResetPasswordRequested).customerId} />;
            case OrderPlaceSucceed.type:
                return (
                    <PopupOrdersPlaced
                        articlesOrdersDrafts={(event as OrderPlaceSucceed).articlesOrdersDrafts!}
                        itemValidationResult={(event as OrderPlaceSucceed).itemValidationResult}
                    />
                );
            case OrderImportSucceed.type:
                return (
                    <PopupOrdersImported
                        articlesOrdersDrafts={(event as OrderPlaceSucceed).articlesOrdersDrafts!}
                        itemValidationResult={(event as OrderPlaceSucceed).itemValidationResult}
                    />
                );
            default:
                return null;
        }
    };

    private closePopup = (): void => {
        this.props.dispatch(new NotificationConsumed(this.getNotifications()[0].id));
        document.body.classList.remove('no-scroll');
    };
}

const mapStateToProps = (state: State): StateProps => ({
    notifications: state.notifications
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Popup);



// WEBPACK FOOTER //
// ./src/view/popup/Popup.tsx